/*@flow*/

export default function scrollContainerTop() {
  const el = $('.drawer > div').get(0);
  if (!el) return;
  el.scrollTop = 0;
}
